export enum AllowedGDPRFileType {
  JPG = "image/jpg",
  JPEG = "image/jpeg",
  PNG = "image/png",
}
